/** Plain-language Talent browse copy. Recruiters see this above the directory. */
export const TALENT_BROWSE_HINT =
  'These are people you have added. Open Analysis to rank them for a role.'

/** Empty Talent directory. The Upload files button sits under this line. */
export const TALENT_EMPTY_DESCRIPTION = 'Upload a CV to add the first person.'

/** Subtitle on the Talent Analysis tab. */
export const TALENT_ANALYSIS_DESCRIPTION =
  'Ranks the people you have added. Set the skills you need, then run analysis.'
